import React, { useEffect, useContext, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import useValidationInput from "../../../Hooks/useValidationInput.js";
import useAxiosOperation from "../../../Hooks/useAxiosOperation.js";
import SpinnerIcon from "../../Commands/SpinnerIcon/SpinnerIcon.js";
import useLogIcon from "../../../Hooks/useLogIcon.js";
import { useHistory } from "react-router-dom";
import "../../Styles/globalStyle.css";
import { store } from "../../../store.js";
import Cookies from "js-cookie"
import ExpandCommand from "../../Commands/ExpandCommand/ExpandCommand";
import CollapseCommand from "../../Commands/CollapseCommand/CollapseCommand";
import TaskIcon from "../../Commands/TaskIcon/TaskIcon";
import FormIcon from "../../Commands/FormIcon/FormIcon";
import UserIcon from "../../Commands/UserIcon/UserIcon";
import Autocomplete from "../../Autocomplete/Autocomplete";

export default function  Task (props) {
   

  return (
    
    <div style = {{  lineHeight:"15px",marginRight:"5px",  minWidth:"160px",  maxWidth:"160px"
        , padding: "10px"
        , marginTop: "10px"
        , minHeight: "80px"
        , border: "1px solid lightGray"  ,flex:1, flexDirection:'row'
        , backgroundColor: "white" 
        , borderLeft:"2px solid limeGreen"}}
        draggable = {true}
        >
        <span style = {{  fontSize:"12px", fontFamily:"segoe UI"}} >
          <div style = {{  marginTop:"2px", marginRight:"5px", float: "left"}}>
            <TaskIcon />
          </div>
            Demande  hgfghftrtyrtyrtyr
          </span>          
          <div style={{ display:"flex", height: "25px", marginTop: "12px", marginBottom: "5px" }}>
            <UserIcon />
            <Autocomplete 
              id={"Process" +props.id} //id={"Autocomplete" + fieldId}
              placeholder={"Unassigned"}
              isWrapped = {true}     
              style={{ width:"130px", height:"12px", fontFamily: "segoe UI", fontSize: "12px"}}
              containerStyle={{width:"142px", border: "1px solid red"}}
              emphasised= {false}
              value={undefined}
              data = {[{id:1, item:"Open"}, {id:2, item:"Closed"}]}
             
              onSelectedItem={(e, itemSelected) => alert(1)}/>
          </div>
          <div style = {{ marginLeft:"70px", fontSize:"12px", fontFamily:"segoe UI"}}>Priority: Medium</div> 
      </div>
    
  );
};

/*
<span style = {{ fontSize:"14px", width:"250px", color:"#212121" }} >Register</span>*/